import { useState } from 'react';
import { Title } from 'components/Title';

import ThermalInvoice from './ThermalInvoice'
export default function ThermalPage() {
	
	const [pageReady, setPageReady] = useState(true);
	const [selectedBookingId, setSelectedBookingId] = useState(null);
	return (
		<main id="ThermalPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="Thermal"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div className="booking-selector">
                        <h2>Invoice Print</h2>
                        <input  
                        type="number" 
                        placeholder="Enter Booking ID"
                        onChange={(e) => setSelectedBookingId(e.target.value)}
                        value={selectedBookingId || ''}
                        />
                        {selectedBookingId && (
                        <button  onClick={() => setSelectedBookingId(selectedBookingId)}>
                        Generate Invoice
                        </button>
                        )}
                    </div>
                    {selectedBookingId && <ThermalInvoice bookingId={selectedBookingId} />}
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
